import {HTMLAttributes} from 'react';
import {twMerge} from '../../../common/twMerge';
import {Maybe} from '../../../graphql/generated/types';
import {Text} from '../../atoms/Text/Text';
import {CheckBox} from '../../molecules/CheckBox/CheckBox';
import {CheckBoxSize} from '../../molecules/CheckBox/CheckBoxSize.enum';

interface BelowTabCheckBoxProps extends HTMLAttributes<HTMLDivElement> {
  isChecked?: Maybe<boolean>;
  size?: CheckBoxSize;
}

export function BelowTabCheckBox({
  isChecked,
  children,
  className,
  size = CheckBoxSize.Small,
  ...props
}: BelowTabCheckBoxProps) {
  return (
    <div
      className={twMerge(
        'flex shrink-0 cursor-pointer select-none items-center justify-center space-x-4pxr',
        className
      )}
      {...props}
    >
      {size !== CheckBoxSize.Small && (
        <CheckBox checked={isChecked} size={size} />
      )}
      <Text
        className={twMerge(
          'font-small2 mr-4pxr text-theme-solid-100',
          size === CheckBoxSize.ContentHome &&
            'font-small2-bold text-theme-solid-60'
        )}
      >
        {children}
      </Text>
      {size === CheckBoxSize.Small && (
        <CheckBox checked={isChecked} size={size} />
      )}
    </div>
  );
}

export const BelowTabCheckBoxType = (<BelowTabCheckBox />).type;
